import React from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'

const DEFAULT_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
const DEFAULT_TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'


export default function EventMap({markerTitle, markerPosition}) {

    const tileUrl = process.env.REACT_APP_MAP_TILE_URL || DEFAULT_TILE_URL
    const tileAttribution = process.env.REACT_APP_MAP_TILE_ATTRIBUTION || DEFAULT_TILE_ATTRIBUTION

    return (
        <MapContainer 
            center={markerPosition} 
            zoom={13}  
            > 
            <TileLayer
                attribution={tileAttribution}
                url={tileUrl}
                referrerPolicy="strict-origin-when-cross-origin"
                />
            <Marker position={markerPosition}>
                <Popup>
                    {markerTitle}
                </Popup>
            </Marker> 
        </MapContainer>
    )
}
